interface IsFilteredBy {
  referenceValues: string[];
  includeValue?: string;
}

export function isFilteredBy({ referenceValues, includeValue }: IsFilteredBy): boolean {
  if (!includeValue) {
    return true;
  }

  let isIncludedValue = false;
  const sanitizedIncludedValue = includeValue.trim().toLowerCase();

  referenceValues.forEach((value) => {
    const sanitizedReferenceValue = value && value.trim().toLowerCase();
    const referenceIncludeValue = sanitizedReferenceValue && sanitizedReferenceValue.includes(sanitizedIncludedValue);

    if (referenceIncludeValue) {
      isIncludedValue = true;
    }
  });

  return isIncludedValue;
}
